import { SVGProps } from 'react';

export const LocationList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00059 6.02267C9.70524 6.02267 10.2756 5.45231 10.2756 4.74766C10.2756 4.04301 9.70524 3.47266 9.00059 3.47266C8.29594 3.47266 7.72559 4.04301 7.72559 4.74766C7.72559 5.45231 8.29594 6.02267 9.00059 6.02267Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00076 2.20074C10.4092 2.20074 11.5508 3.34229 11.5508 4.75075C11.5508 5.99941 9.47251 11.2499 9.00076 12.4008C8.52645 11.2363 6.45075 6.00366 6.45075 4.75075C6.45075 3.34229 7.5923 2.20074 9.00076 2.20074ZM17.4127 15.262L15.3378 11.012C15.1066 10.3184 14.4564 9.85004 13.7254 9.85004H11.733C12.5277 7.83128 13.2502 5.73007 13.2502 4.75002C13.2502 2.40656 11.3437 0.5 9.00022 0.5C6.65676 0.5 4.7502 2.40656 4.7502 4.75002C4.7502 5.73007 5.4727 7.83128 6.26746 9.85004H4.27505C3.54405 9.85004 2.89379 10.3184 2.66259 11.012L0.587735 15.262C0.414334 15.7814 0.501035 16.3509 0.820636 16.7946C1.14024 17.2374 1.65364 17.5001 2.20019 17.5001H15.8002C16.3468 17.5001 16.8602 17.2374 17.1798 16.7946C17.4994 16.3509 17.5861 15.7814 17.4127 15.262Z"
      fill="currentColor"
    />
  </svg>
);
